// Set Webpack's public path to what the renderer service dictates, so that lazy-loaded bundles are grabbed from the
// right place.
import { readHostingConfiguration } from '@ms/yammer-web-support/dist/hosting';

__webpack_public_path__ = readHostingConfiguration().scriptBaseUrl || '/';
